import { configureStore } from '@reduxjs/toolkit'

import authReducer from './reducers/authSlice'

// Initial state for the sidebar
const initialState = {
  sidebarShow: true,
}

// Reducer function to handle changes to the sidebar state
const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const wallpaperReducer = (state = '#EBEDEF', action) => {
  switch (action.type) {
    case 'set_wallpaper':
      return action.payload
    case 'reset_wallpaper':
      return '#EBEDEF'
    default:
      return state
  }
}

// Combine reducers from Redux Toolkit and custom reducer
const rootReducer = {
  auth: authReducer,
  sidebar: changeState,
  wallpaperColor: wallpaperReducer,
}

// Create the Redux store
const store = configureStore({
  reducer: rootReducer,
})

export default store
